import { useEffect } from 'react'

export interface PageTitleProps {
  title: string
}

export function PageTitle({ title }: Readonly<PageTitleProps>) {
  useEffect(() => {
    document.title = title
  }, [title])

  return null
}
